import React, { useCallback, useMemo } from 'react'
import './styles.css'
import { authState } from '../../state/Auth.state'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { Loading } from '../loading/Loading'


export const Login = () => {
    /* STATE */
/*
    const [igvKennung, setIgvKennung] = React.useState('')
    const [password, setPassword] = React.useState('')

    const [igvKennung, setIgvKennung] = React.useState('778')
    const [password, setPassword] = React.useState('TESTIGV') //6A15992F9656')
*/

    const [igvKennung, setIgvKennung] = React.useState('')
    const [password, setPassword] = React.useState('')

    const [loading, setLoading] = React.useState(false)

    /* DERIVED STATE */
    const btnDisabled = useMemo(() => !igvKennung || !password || !/^\d+$/.test(igvKennung), [igvKennung, password])

    /* LOGIC */
    const login = useCallback(() => {
        if (igvKennung && password) {
            setLoading(true)
            return authState.login(parseInt(igvKennung, 10), password).finally(() => setLoading(false))
        }
    }, [igvKennung, password])

    const register = useCallback(() => {
        window.location.hash = '#/register'
    }, [])

    const forgotpassword = useCallback(() => {
        window.location.hash = '#/forgotpassword'
    }, [])

    /* TEMPLATE */
    return (
        <>
            <Loading loading={loading} />
            <div className='login-container'>
                <div className='login-form card'>
                    <h2 style={{ marginBottom: '1rem' }}>Login</h2>
                    <InputText
                        keyfilter='int'
                        placeholder='IGV-Kennung'
                        value={igvKennung}
                        onChange={(e) => setIgvKennung(e.target.value ?? '')}
                    />
                    <InputText
                        type='password'
                        placeholder='Passwort'
                        value={password}
                        onChange={(e) => setPassword(e.target.value ?? '')}
                    />
                    <Button onClick={login} disabled={btnDisabled} label='Login' />
                    <Button onClick={register} outlined label='Keine Zugangsdaten? Hier Registrieren' />
                    <Button onClick={forgotpassword} outlined label='Zugangsdaten vergessen?' />
                </div>
            </div>
        </>
    )
}
